import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagMA(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAYUExURdk2PuA5QskuNtEyOsMrMw1gNU1RN5VBORzsibUAAAGkSURBVDjL3ZE7b9tAEIRXOSBu6X8g8Ii4PfAgpzUuBNLHWLINZDO14UDO38/M7lEUAVtligzvtTPfLfWQ2+tq5P8Amut5IzuTNI1vu7NoSSO+rdaNY/UCzpWgx7U5JLFcvLaHFIV2sju92L7kS7bzFHP+uVTL3Croo1zVjU7vuMmG6bOO1fGGnCFISqHqoJogSS4SnkswT06qL6gySvKJzaGQckr3vyBVHbl7gxCyNctE86cZqU5c9JgDXQyRnDO4jPGV0ROxiZcSg5CEIN8ABB/gz7fvWH8z4x2+Iq8Ks07sc0xW2roBGOYDoAttgTyPb2/69DEQdcTzGPtLoHdluNG+B17Bc/WTxMjSZrw3YOyzX8mY3iFWHv/EEb8DeXq4Evfo0BJpWZ50ineqr21vHqO94Ni2zNsY57H0+Yse+2gGMHRADCS21PzK9fTDCuQQOlThxt2znbpn3nWkXwEmdRsuvA1wVnkP6GCXTacKdFBbOs+LH7tVDnRdgQZuS7EClpzHUE+VKMNeBpcF3EgtFvQgxKtXiifsMzjePSwdPtK/AP4CJZzUEzZEbRAAAAAASUVORK5CYII=",
    alt: "MA"
  }, props));
}